import type { FunctionalComponent as FC } from 'preact';

import { Icon56CommentsOutline } from '@vkontakte/icons';
import { Placeholder } from '@vkontakte/vkui';

import { useWidget } from '../../context/WidgetContext';

interface Props {
  className?: string;
}

export const EmptyWidgetContent: FC<Props> = ({ className }) => {
  const { localeMessages } = useWidget();
  return (
    <Placeholder
      className={className}
      icon={<Icon56CommentsOutline />}
      title={localeMessages.chat.startChatTitle}
      stretched
    >
      {localeMessages.chat.startChatDescription}
    </Placeholder>
  );
};
